import React from 'react';
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function CryptoLicenseMwali (){

    return (
        <main className='main'>

            <SEO
                title="Mwali Crypto License | VASP & Exchange Setup Comoros "
                description="Get a crypto license in Mwali (Comoros). Expert support for MISA approval, exchanges, wallets, VASP registration, and full compliance setup. "
                keywords="Mwali crypto license, Comoros VASP license, MISA crypto license, crypto exchange Comoros, wallet license crypto, DLT tokenization license, blockchain licensing, offshore crypto services "
                url="/crypto-license-mwali"
            />

            <IntroSection
                title="Crypto License – Mwali (Comoros)"
                subtitle="Operate Your Crypto Business with a MISA License"
                description={`
                    Mwali (Mohéli, Comoros), through the Mwali International Services Authority (MISA), offers Crypto & Virtual Asset Licenses for companies seeking a credible offshore base. With strong regulatory oversight, moderate requirements, and global recognition, Mwali is a leading offshore hub for exchanges, wallet providers, token projects, and blockchain firms.
                `}
                badges={
                    [
                        "Crypto Exchange License",
                        "Custodian & Wallet License",
                        "VASP Registration",
                        "DLT & Tokenization"
                    ]
                }
                buttonText="Request a Mwali Crypto License Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/crypto-license-western-mwali-hero.png")}
                imageAlt="Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title=' Why Choose Mwali for Crypto?'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            "title": "Global Recognition",
                                            "text": "Trusted more than newer jurisdictions (Western Sahara, Anjouan)."
                                        },
                                        {
                                            "title": "Regulated by MISA",
                                            "text": "Compliance-oriented and FATF-aligned."
                                        },
                                        {
                                            "title": "Wide Range of Crypto Services",
                                            "text": "Exchanges, custody, tokenization, payment gateways."
                                        },
                                        {
                                            "title": "Banking & PSP Access",
                                            "text": "Better onboarding than many unregulated offshore centers."
                                        },
                                        {
                                            "title": "Affordable & Faster",
                                            "text": "Cheaper and faster than Malta, Gibraltar, or Estonia."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="What the License Covers"
                        subtitle='With a CRA Crypto License, your company can operate:'
                        item={
                            [
                                {
                                    "title": "Crypto Exchange (CEX & DEX)",
                                    "text": "Spot trading, swaps, and CFDs on digital assets."
                                },
                                {
                                    "title": "Custodian & Wallet Services",
                                    "text": "Hot and cold storage solutions for client funds."
                                },
                                {
                                    "title": "Virtual Asset Service Provider (VASP) Registration",
                                    "text": "FATF-compliant structure for VASP authorization."
                                },
                                {
                                    "title": "Token Issuance & ICO/IEO/STO",
                                    "text": "Legally launch token projects and raise capital."
                                },
                                {
                                    "title": "DeFi & NFT Platforms",
                                    "text": "Run decentralized apps and NFT marketplaces."
                                },
                                {
                                    "title": "Crypto Payment Services",
                                    "text": "Payment gateways for merchants accepting crypto."
                                }
                            ]
                        }
                    />


                    <InfoBlocks
                        title="What the License Covers"
                        subtitle='With a Mwali Crypto License, your company can operate:'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            "title": "Crypto Exchanges (CEX & DEX)",
                                            "text": "Spot, margin, and derivatives trading."
                                        },
                                        {
                                            "title": "Custodian & Wallet Services",
                                            "text": "Hot/cold storage for client funds."
                                        },
                                        {
                                            "title": "VASP Registration",
                                            "text": "Virtual Asset Service Provider under FATF standards."
                                        },
                                        {
                                            "title": "Token Issuance & STO/ICO/IEO Projects",
                                            "text": "Launch coins, tokens, and blockchain platforms."
                                        },
                                        {
                                            "title": "Crypto Payment Gateways",
                                            "text": "Accept and process crypto payments for merchants."
                                        },
                                        {
                                            "title": "DeFi & NFT Platforms",
                                            "text": "Operate decentralized applications and marketplaces."
                                        }
                                    ]
                            }
                        ]}
                    />


                    <ServiceCards
                        title='Capital Requirements'
                        services={
                            [
                                { "text": "Flexible compared to EU regulators." },
                                { "text": "Typically USD 10,000–12,000+, depending on the business model." },
                                { "text": "Final amount set by MISA during application review." }
                            ]

                        }
                        />

                    <DetailsSection
                        title='Benefits of a Mwali Crypto License'
                        items={
                            [
                                {
                                    "title": "Credibility",
                                    "text": "Accepted by exchanges, PSPs, and investors."
                                },
                                {
                                    "title": "Banking Access",
                                    "text": "Higher chances of securing EMI/crypto bank accounts."
                                },
                                {
                                    "title": "Compliance-Oriented",
                                    "text": "AML/KYC aligned with FATF guidance."
                                },
                                {
                                    "title": "Fast Setup",
                                    "text": "2–3 weeks (faster than EU regulators)."
                                },
                                {
                                    "title": "Scalable",
                                    "text": "Expand services from exchange to custody, tokens, and DeFi."
                                }
                            ]
                        }
                        />

                    <LocationTimeline
                        title="Licensing Process"
                        subtitle='With a CRA Crypto License, your company can operate:'
                        item={
                            [
                                {
                                    "title": "Consultation & Planning",
                                    "text": "Define business model (exchange, wallet, payment, tokenization)."
                                },
                                {
                                    "title": "Company Incorporation",
                                    "text": "Register an IBC in Mwali (Comoros)."
                                },
                                {
                                    "title": "Compliance Setup",
                                    "text": "Draft AML/KYC manuals, risk framework, and business plan."
                                },
                                {
                                    "title": "Application Filing",
                                    "text": "Offshore Advisory submits to MISA."
                                },
                                {
                                    "title": "Approval & Activation",
                                    "text": "License granted in 2–3 weeks."
                                }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "2-3 weeks.",
                            },
                            {
                                name: "Setup Cost",
                                description: "from USD 10,000+",
                            },
                            {
                                name: "Renewal",
                                description: "annual fees payable to MISA",
                            },
                            {
                                name: "Capital Requirement",
                                description: "USD 25k–50k+ (flexible)",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { "text": "Recognized MISA agent with crypto licensing expertise." },
                                { "text": "End-to-end services: incorporation, compliance, licensing, PSP onboarding." },
                                { "text": "Access to crypto-friendly PSPs & EMI providers." },
                                { "text": "Support for exchange platforms, wallet providers, and DeFi projects." },
                                { "text": "White-label crypto exchange & wallet solutions available." }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "Ready to launch your crypto business?"
                         description=
                             "Mwali offers a <b>credible, compliance-friendly offshore crypto license</b> with <b>faster timelines</b> and <b>lower costs than EU regulators</b>."
                         buttonText='Book a Mwali Crypto License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is a Mwali crypto license recognized globally?",
        content: [
            { type: "answer", text: "Yes — it has credibility with PSPs, exchanges, and investors, unlike new regulators." },
        ],
    },
    {
        question: "How long does it take to get licensed?",
        content: [
            { type: "answer", text: "Typically 2–3 weeks." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "Flexible — usually USD 25k–50k+, depending on your model." },
        ],
    },
    {
        question: "Can I operate a DeFi or NFT project under this license?",
        content: [
            { type: "answer", text: "Yes — CRA allows tokenization, DeFi platforms, and NFT marketplaces." },
        ],
    },
    {
        question: "Do you provide technical integration?",
        content: [
            { type: "answer", text: "Yes — Offshore Advisory connects clients with white-label exchange and wallet software providers." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We obtained our Mwali crypto license in under 3 months. Offshore Advisory helped with PSP setup and white-label exchange software.",
            author: "Alex R.",
            role: "Exchange Founder"
        },
        {
            quote: "Mwali gave us credibility for tokenization projects. Offshore Advisory’s compliance support was excellent.",
            author: "Sofia M.",
            role: "Blockchain Entrepreneur"
        }
    ]
;